import React from "react";
import Certificate from "../assets/Capture1.PNG";
import Section from "./common/Section";

const AboutMe = () => {
  return (
    <div>
      <Section title="About me">
        <section className="lg:flex">
          <div className="flex-1 flex justify-center items-center">
            <img
              src={Certificate}
              alt="avatar"
              className="w-70 h-70 p-20 duration-300 ease-in-out hover:scale-110 flex justify-around items-center object-cover object-top rounded pt-5"
            />
          </div>
          <div className="flex-1 flex flex-col justify-start items-start">
            <h2 className="text-5xl text-rose-600 font-medium text-center mt-10">
              I am Anup Poudel
            </h2>
            <p className="mt-10 text-justify place-items-start">
              Experienced and competent bachelor of information technology
              graduate with advanced knowledge of writing codes in HTML, CSS,
              JavaScript ES6, React and Node.js. My academics studies and
              experience have reinforced my technical and soft skills. I bring
              to table, my unique mixture of coding skills and comprehensive
              problem solving knowledge, assisting the company in meeting and
              surpassing relevant organizational goals.
            </p>
          </div>
        </section>
      </Section>
    </div>
  );
};

export default AboutMe;
